module.exports = require("mdi-material-ui/Microphone");